module.exports = __webpack_public_path__ + "img/lederhosen-land-logo.29052ed7.png";